import { render, staticRenderFns } from "./PolizasIETabs.vue?vue&type=template&id=40d824c4&scoped=true&"
import script from "./PolizasIETabs.vue?vue&type=script&lang=js&"
export * from "./PolizasIETabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d824c4",
  null
  
)

export default component.exports